/* eslint react/no-unused-prop-types: "off" */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ContactList from '@/connectHOCs/Contacts/ContactList';
import ownerGuidHOC from '@/connectHOCs/Sessions/currentSession/ownerGuid';
import ContactProxy from '@/Proxies/ContactProxy';
import ContactItem, { GroupContactItem } from './ContactItem';
import styles from './ContactBucket.css';

const bucketIdI18NMap = {
  openChannel: 'open_groups_separator',
  federated: 'other_contacts_separator',
  invited: 'invited_but_not_joined',
  imported: 'imported_contacts_separator',
};

class ContactBucket extends PureComponent {
  static propTypes = {
    contactIds: PropTypes.array,
    bucketId: PropTypes.string,
    activeIndex: PropTypes.number,
    showHeader: PropTypes.bool,
    onItemClick: PropTypes.func,
    customFieldsMap: PropTypes.object,
  };

  static defaultProps = {
    contactIds: [],
    bucketId: '',
    activeIndex: -1,
    showHeader: false,
    onItemClick: () => {},
    customFieldsMap: undefined,
  };

  constructor(props) {
    super(props);
    const { ownerGuid, contactIds = [] } = this.props;
    this.contactProxySub = ContactProxy.subscribe(ownerGuid, contactIds);
  }

  componentDidUpdate() {
    const { ownerGuid, contactIds = [] } = this.props;
    this.contactProxySub.update(
      ownerGuid,
      contactIds.filter(c => !c.isTempSearchContact)
    );
  }

  componentWillUnmount() {
    this.contactProxySub.unsubscribe();
  }

  render() {
    const {
      bucketId,
      activeIndex,
      contacts,
      showHeader,
      customFieldsMap,
      onItemClick,
    } = this.props;

    return (
      <div>
        {showHeader ? (
          <div className={styles.header}>
            <FormattedMessage id={bucketIdI18NMap[bucketId]} />
          </div>
        ) : null}
        {contacts.map((c, i) => (
          <li
            key={c.isTempSearchContact ? 'temp' : c.jid}
            role='option'
            aria-selected={activeIndex === i}
            className={`${styles.li} ${activeIndex === i ? styles.active : ''}`}
            onClick={() => onItemClick(c.jid)}
            onKeyDown={() => {}}
          >
            {c.isGroup ? (
              <GroupContactItem contact={c} customFieldsMap={customFieldsMap} />
            ) : (
              <ContactItem contact={c} customFieldsMap={customFieldsMap} />
            )}
          </li>
        ))}
      </div>
    );
  }
}

export default ownerGuidHOC(
  ContactList(ContactBucket, 'contactIds', 'ownerGuid')
);



// WEBPACK FOOTER //
// ./src/components/Search/ContactSearch/ContactList/ContactBucket/ContactBucket.js